import React, { useEffect } from 'react';
import AdminDetailPageTemplate from '../../04_templates/AdminDetailPageTemplate/AdminDetailPageTemplate';

function AdminDetailPage() {
  useEffect(() => {
    document.title = 'Sweet Bibi - Boek Details';
  }, []);
  
  return (
    <main>
      <AdminDetailPageTemplate />
    </main>
  );
}

export default AdminDetailPage;
